/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
import '../common/location';
import '../common/address';
import '../common/countries';
import '../common/script';
import './format';
import './country_data';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "address": {
        "nested": {
          "service": {
            "nested": {
              "Coordinates": {
                "fields": {
                  "latitude": {
                    "type": "double",
                    "id": 1,
                    "rule": "optional"
                  },
                  "longitude": {
                    "type": "double",
                    "id": 2,
                    "rule": "optional"
                  },
                  "altitudeMeters": {
                    "type": "double",
                    "id": 3,
                    "rule": "optional"
                  },
                  "geocodeAccuracy": {
                    "type": "squareup.address.service.Coordinates.GeocodeAccuracy",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "GeocodeAccuracy": {
                    "values": {
                      "UNKNOWN": 0,
                      "ADMINISTRATIVE_AREA": 2,
                      "LOCALITY": 4,
                      "SUB_LOCALITY": 6,
                      "POSTAL_CODE": 8,
                      "BLOCK": 10,
                      "THOROUGHFARE": 12,
                      "THOROUGHFARE_SEGMENT": 14,
                      "INTERPOLATED_PREMISES": 16,
                      "PREMISES": 18,
                      "SUBPREMISES": 20,
                      "MANUAL": 31
                    }
                  }
                }
              },
              "PiiStatusScope": {
                "fields": {},
                "nested": {
                  "PiiStatus": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "MIXED": 1,
                      "KNOWN_PII": 2,
                      "KNOWN_NOT_PII": 3
                    }
                  }
                }
              },
              "ResidentialScope": {
                "fields": {},
                "nested": {
                  "Residential": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "RESIDENTIAL": 1,
                      "COMMERCIAL": 2
                    }
                  }
                }
              },
              "AddressTypeScope": {
                "fields": {},
                "nested": {
                  "AddressType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "FIRM": 1,
                      "GENERAL_DELIVERY": 2,
                      "HIGH_RISE_OR_COMPLEX": 3,
                      "PO_BOX": 4,
                      "RURAL_ROUTE": 5,
                      "STREET": 6,
                      "MIXED": 7,
                      "SMALL": 8,
                      "LARGE": 9
                    }
                  }
                }
              },
              "Address": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "globalAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  },
                  "coordinates": {
                    "type": "squareup.address.service.Coordinates",
                    "id": 3,
                    "rule": "optional"
                  },
                  "piiStatus": {
                    "type": "squareup.address.service.PiiStatusScope.PiiStatus",
                    "id": 4,
                    "rule": "optional"
                  },
                  "verification": {
                    "type": "squareup.address.service.Verification",
                    "id": 5,
                    "rule": "optional"
                  },
                  "residential": {
                    "type": "squareup.address.service.ResidentialScope.Residential",
                    "id": 6,
                    "rule": "optional"
                  },
                  "addressType": {
                    "type": "squareup.address.service.AddressTypeScope.AddressType",
                    "id": 7,
                    "rule": "optional"
                  },
                  "addressVerificationDebugging": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "geocodeDebugging": {
                    "type": "string",
                    "id": 9,
                    "rule": "optional"
                  }
                }
              },
              "Verification": {
                "fields": {
                  "verificationStatus": {
                    "type": "squareup.address.service.Verification.VerificationStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "verificationLevel": {
                    "type": "squareup.address.service.Verification.VerificationLevel",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "VerificationStatus": {
                    "values": {
                      "INVALID_STATUS": 0,
                      "VERIFY_FAILED": 1,
                      "PARTIALLY_VERIFIED": 2,
                      "VERIFIED": 3
                    }
                  },
                  "VerificationLevel": {
                    "values": {
                      "INVALID_LEVEL": 0,
                      "ADMINISTRATIVE_AREA": 1,
                      "LOCALITY": 2,
                      "THOROUGHFARE": 3,
                      "PREMISES": 4,
                      "SUBPREMISES": 5
                    }
                  }
                }
              },
              "RequirementsScope": {
                "fields": {},
                "nested": {
                  "Requirements": {
                    "values": {
                      "INVALID": 0,
                      "MUST_NOT_CHANGE": 1,
                      "STORE_UNCHANGED": 2,
                      "DO_NOT_STORE": 3,
                      "GEOCODABLE": 4
                    }
                  }
                }
              },
              "ServicesScope": {
                "fields": {},
                "nested": {
                  "Services": {
                    "values": {
                      "INVALID": 0,
                      "GEOCODING": 1
                    }
                  }
                }
              },
              "FlagsScope": {
                "fields": {},
                "nested": {
                  "Flags": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "GEOCODING_HQ": 1,
                      "VERIFICATION_OPTIONAL": 2,
                      "KANJI_SCRIPTADDRESS_VALIDATION": 3,
                      "KANA_SCRIPTADDRESS_VALIDATION": 4
                    }
                  }
                }
              },
              "RequestContext": {
                "fields": {
                  "traceId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientOu": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "methodName": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "AsyncJob": {
                "fields": {
                  "addressToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "services": {
                    "type": "squareup.address.service.ServicesScope.Services",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "flags": {
                    "type": "squareup.address.service.FlagsScope.Flags",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "requestContext": {
                    "type": "squareup.address.service.RequestContext",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "StoreRequest": {
                "fields": {
                  "requirements": {
                    "type": "squareup.address.service.RequirementsScope.Requirements",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "services": {
                    "type": "squareup.address.service.ServicesScope.Services",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "flags": {
                    "type": "squareup.address.service.FlagsScope.Flags",
                    "id": 4,
                    "rule": "repeated"
                  },
                  "piiStatus": {
                    "type": "squareup.address.service.PiiStatusScope.PiiStatus",
                    "id": 5,
                    "rule": "optional"
                  },
                  "globalAddress": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 1
                  },
                  "address": {
                    "type": "squareup.common.address.Address",
                    "id": 6
                  }
                },
                "nested": {
                  "Constants": {
                    "values": {
                      "MAX_TEXT_LEN": 191
                    }
                  },
                  "input_address": {
                    "oneof": ["globalAddress", "address"]
                  }
                }
              },
              "AddressResult": {
                "fields": {
                  "status": {
                    "type": "squareup.address.service.AddressResult.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "failedRequirements": {
                    "type": "squareup.address.service.RequirementsScope.Requirements",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "address": {
                    "type": "squareup.address.service.Address",
                    "id": 3,
                    "rule": "optional"
                  },
                  "result": {
                    "type": "squareup.common.address.Address",
                    "id": 4,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "INVALID": 0,
                      "SUCCESS": 1,
                      "FAILED_REQUIREMENTS": 2,
                      "FAILED_VERIFICATION": 3,
                      "VERIFICATION_NOT_AVAILABLE": 4,
                      "KANJI_POSTAL_CODE_INVALID": 7,
                      "KANJI_CHOME_BANCHI_INVALID": 8,
                      "KANJI_BUILDING_NAME_MISSING": 9,
                      "KANA_BUILDING_NAME_MISSING": 10,
                      "KANA_INVALID_CHARACTERS": 11,
                      "KANJI_PREFECTURE_MISSING": 12,
                      "KANJI_CITY_MISSING": 13,
                      "KANJI_AREA_MISSING": 14
                    }
                  }
                }
              },
              "RetrieveRequest": {
                "fields": {
                  "tokens": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "RetrieveResponse": {
                "fields": {
                  "addresses": {
                    "type": "squareup.address.service.Address",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "results": {
                    "type": "squareup.common.address.Address",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "RetrieveWithUpgradeRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "requirements": {
                    "type": "squareup.address.service.RequirementsScope.Requirements",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "services": {
                    "type": "squareup.address.service.ServicesScope.Services",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "flags": {
                    "type": "squareup.address.service.FlagsScope.Flags",
                    "id": 4,
                    "rule": "repeated"
                  }
                }
              },
              "LookupPostalCodeRequest": {
                "fields": {
                  "countryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 1,
                    "rule": "optional"
                  },
                  "postalCode": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "LookupPostalCodeResponse": {
                "fields": {
                  "postalCodeFormat": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "minLength": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  },
                  "prefixOnly": {
                    "type": "bool",
                    "id": 3,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "matches": {
                    "type": "squareup.address.service.LookupPostalCodeResponse.Match",
                    "id": 5,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Match": {
                    "fields": {
                      "id": {
                        "type": "int64",
                        "id": 1,
                        "rule": "optional"
                      },
                      "placeDisplayName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "globalAddress": {
                        "type": "squareup.common.location.GlobalAddress",
                        "id": 3,
                        "rule": "optional"
                      },
                      "address": {
                        "type": "squareup.common.address.Address",
                        "id": 4,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "ReverseGeocodeRequest": {
                "fields": {
                  "coordinates": {
                    "type": "squareup.address.service.Coordinates",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ReverseGeocodeResponse": {
                "fields": {
                  "entries": {
                    "type": "squareup.address.service.ReverseGeocodeResponse.Entry",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "Entry": {
                    "fields": {
                      "globalAddress": {
                        "type": "squareup.common.location.GlobalAddress",
                        "id": 1,
                        "rule": "optional"
                      },
                      "accuracy": {
                        "type": "double",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "LookupCountryAddressDataRequest": {
                "fields": {
                  "countryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetAutocompleteCandidatesRequest": {
                "fields": {
                  "partialAddress": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sessionToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.address.service.PlaceAutocompleteTypesScope.PlaceAutocompleteType",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "PlaceAutocompleteTypesScope": {
                "fields": {},
                "nested": {
                  "PlaceAutocompleteType": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "GEOCODE": 1,
                      "ADDRESS": 2,
                      "ESTABLISHMENT": 3,
                      "REGIONS": 4,
                      "CITIES": 5
                    }
                  }
                }
              },
              "GetAutocompleteCandidatesResponse": {
                "fields": {
                  "candidates": {
                    "type": "squareup.address.service.GetAutocompleteCandidatesResponse.AddressCandidate",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "AddressCandidate": {
                    "fields": {
                      "combinedAddress": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "placeId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "structuredFormatting": {
                        "type": "squareup.address.service.GetAutocompleteCandidatesResponse.PlaceAutocompleteStructuredFormat",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "PlaceAutocompleteStructuredFormat": {
                    "fields": {
                      "mainText": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "secondaryText": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "GetPlaceDetailsRequest": {
                "fields": {
                  "placeId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sessionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "GetPlaceDetailsResponse": {
                "fields": {
                  "placeId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "address": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  },
                  "coordinates": {
                    "type": "squareup.address.service.Coordinates",
                    "id": 3,
                    "rule": "optional"
                  },
                  "formattedAddress": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "FeGetAutocompleteCandidatesRequest": {
                "fields": {
                  "partialAddress": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "countryCode": {
                    "type": "squareup.common.countries.Country",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sessionToken": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.address.service.PlaceAutocompleteTypesScope.PlaceAutocompleteType",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "FeGetAutocompleteCandidatesResponse": {
                "fields": {
                  "candidates": {
                    "type": "squareup.address.service.FeGetAutocompleteCandidatesResponse.AddressCandidate",
                    "id": 1,
                    "rule": "repeated"
                  }
                },
                "nested": {
                  "AddressCandidate": {
                    "fields": {
                      "combinedAddress": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "placeId": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "structuredFormatting": {
                        "type": "squareup.address.service.FeGetAutocompleteCandidatesResponse.PlaceAutocompleteStructuredFormat",
                        "id": 3,
                        "rule": "optional"
                      }
                    }
                  },
                  "PlaceAutocompleteStructuredFormat": {
                    "fields": {
                      "mainText": {
                        "type": "string",
                        "id": 1,
                        "rule": "optional"
                      },
                      "secondaryText": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      }
                    }
                  }
                }
              },
              "FeGetPlaceDetailsRequest": {
                "fields": {
                  "placeId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sessionToken": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FeGetPlaceDetailsResponse": {
                "fields": {
                  "placeId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "address": {
                    "type": "squareup.common.location.GlobalAddress",
                    "id": 2,
                    "rule": "optional"
                  },
                  "coordinates": {
                    "type": "squareup.address.service.Coordinates",
                    "id": 3,
                    "rule": "optional"
                  },
                  "formattedAddress": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "name": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  }
                }
              },
              "FeCountryAddressDataRequest": {
                "fields": {
                  "country": {
                    "type": "squareup.common.countries.Country",
                    "id": 1,
                    "rule": "optional"
                  },
                  "locale": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FeFormatRequest": {
                "fields": {
                  "address": {
                    "type": "squareup.common.address.Address",
                    "id": 1,
                    "rule": "optional"
                  },
                  "script": {
                    "type": "squareup.common.script.Script",
                    "id": 2,
                    "rule": "optional"
                  },
                  "deviceProperties": {
                    "type": "squareup.address.format.DeviceProperties",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FeFormatResponse": {
                "fields": {
                  "error": {
                    "type": "squareup.address.format.FormatAddressResponse.Error",
                    "id": 1,
                    "rule": "optional"
                  },
                  "address": {
                    "type": "squareup.common.address.Address",
                    "id": 2,
                    "rule": "optional"
                  },
                  "lines": {
                    "type": "string",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "FeRetrieveRequest": {
                "fields": {
                  "token": {
                    "type": "string",
                    "id": 1,
                    "rule": "repeated"
                  }
                }
              },
              "FeRetrieveResponse": {
                "fields": {
                  "results": {
                    "type": "squareup.common.address.Address",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "FeValidateAddressRequest": {
                "fields": {
                  "address": {
                    "type": "squareup.common.address.Address",
                    "id": 1,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Constants": {
                    "values": {
                      "MAX_TEXT_LEN": 191
                    }
                  }
                }
              },
              "FeValidateAddressResponse": {
                "fields": {
                  "status": {
                    "type": "squareup.address.service.FeValidateAddressResponse.Status",
                    "id": 1,
                    "rule": "optional"
                  },
                  "result": {
                    "type": "squareup.common.address.Address",
                    "id": 2,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "Status": {
                    "values": {
                      "INVALID": 0,
                      "SUCCESS": 1,
                      "FAILED_VERIFICATION": 2,
                      "VERIFICATION_NOT_AVAILABLE": 3
                    }
                  }
                }
              },
              "AddressService": {
                "methods": {
                  "Store": {
                    "requestType": "squareup.address.service.StoreRequest",
                    "responseType": "squareup.address.service.AddressResult"
                  },
                  "Retrieve": {
                    "requestType": "squareup.address.service.RetrieveRequest",
                    "responseType": "squareup.address.service.RetrieveResponse"
                  },
                  "FormatAddress": {
                    "requestType": "squareup.address.format.FormatAddressRequest",
                    "responseType": "squareup.address.format.FormatAddressResponse"
                  },
                  "LookupCountryAddressData": {
                    "requestType": "squareup.address.service.LookupCountryAddressDataRequest",
                    "responseType": "squareup.address.country_data.CountryAddressData"
                  },
                  "RetrieveWithUpgrade": {
                    "requestType": "squareup.address.service.RetrieveWithUpgradeRequest",
                    "responseType": "squareup.address.service.AddressResult"
                  },
                  "LookupPostalCode": {
                    "requestType": "squareup.address.service.LookupPostalCodeRequest",
                    "responseType": "squareup.address.service.LookupPostalCodeResponse"
                  },
                  "ReverseGeocode": {
                    "requestType": "squareup.address.service.ReverseGeocodeRequest",
                    "responseType": "squareup.address.service.ReverseGeocodeResponse"
                  },
                  "GetAutocompleteCandidates": {
                    "requestType": "squareup.address.service.GetAutocompleteCandidatesRequest",
                    "responseType": "squareup.address.service.GetAutocompleteCandidatesResponse"
                  },
                  "GetPlaceDetails": {
                    "requestType": "squareup.address.service.GetPlaceDetailsRequest",
                    "responseType": "squareup.address.service.GetPlaceDetailsResponse"
                  }
                }
              },
              "AddressFrontendService": {
                "methods": {
                  "Retrieve": {
                    "requestType": "squareup.address.service.FeRetrieveRequest",
                    "responseType": "squareup.address.service.FeRetrieveResponse"
                  },
                  "FormatAddress": {
                    "requestType": "squareup.address.service.FeFormatRequest",
                    "responseType": "squareup.address.service.FeFormatResponse"
                  },
                  "LookupCountryAddressData": {
                    "requestType": "squareup.address.service.FeCountryAddressDataRequest",
                    "responseType": "squareup.address.country_data.CountryAddressData"
                  },
                  "GetAutocompleteCandidates": {
                    "requestType": "squareup.address.service.FeGetAutocompleteCandidatesRequest",
                    "responseType": "squareup.address.service.FeGetAutocompleteCandidatesResponse"
                  },
                  "GetPlaceDetails": {
                    "requestType": "squareup.address.service.FeGetPlaceDetailsRequest",
                    "responseType": "squareup.address.service.FeGetPlaceDetailsResponse"
                  },
                  "ValidateAddress": {
                    "requestType": "squareup.address.service.FeValidateAddressRequest",
                    "responseType": "squareup.address.service.FeValidateAddressResponse"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.Coordinates && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.Coordinates?.nested?.GeocodeAccuracy && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.PiiStatusScope && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.PiiStatusScope?.nested?.PiiStatus && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.ResidentialScope && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.ResidentialScope?.nested?.Residential && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.AddressTypeScope && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.AddressTypeScope?.nested?.AddressType && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.Address && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.Verification && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.Verification?.nested?.VerificationStatus && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.Verification?.nested?.VerificationLevel && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.RequirementsScope && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.RequirementsScope?.nested?.Requirements && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.ServicesScope && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.ServicesScope?.nested?.Services && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FlagsScope && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FlagsScope?.nested?.Flags && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.RequestContext && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.AsyncJob && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.StoreRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.StoreRequest?.nested?.Constants && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.AddressResult && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.AddressResult?.nested?.Status && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.RetrieveRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.RetrieveResponse && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.RetrieveWithUpgradeRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.LookupPostalCodeRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.LookupPostalCodeResponse && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.LookupPostalCodeResponse?.nested?.Match && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.ReverseGeocodeRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.ReverseGeocodeResponse && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.ReverseGeocodeResponse?.nested?.Entry && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.LookupCountryAddressDataRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.GetAutocompleteCandidatesRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.PlaceAutocompleteTypesScope && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.PlaceAutocompleteTypesScope?.nested?.PlaceAutocompleteType && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.GetAutocompleteCandidatesResponse && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.GetAutocompleteCandidatesResponse?.nested?.AddressCandidate && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.GetAutocompleteCandidatesResponse?.nested?.PlaceAutocompleteStructuredFormat && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.GetPlaceDetailsRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.GetPlaceDetailsResponse && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeGetAutocompleteCandidatesRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeGetAutocompleteCandidatesResponse && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeGetAutocompleteCandidatesResponse?.nested?.AddressCandidate && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeGetAutocompleteCandidatesResponse?.nested?.PlaceAutocompleteStructuredFormat && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeGetPlaceDetailsRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeGetPlaceDetailsResponse && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeCountryAddressDataRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeFormatRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeFormatResponse && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeRetrieveRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeRetrieveResponse && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeValidateAddressRequest && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeValidateAddressRequest?.nested?.Constants && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeValidateAddressResponse && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.FeValidateAddressResponse?.nested?.Status && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.AddressService && !$root.nested?.squareup?.nested?.address?.nested?.service?.nested?.AddressFrontendService) {
  $root.addJSON(jsonData);
}

/**
 * ===== BEGIN DEPRECATED DEFINITIONS
 * These will be removed in favor of messages in address.proto, geocode.proto, and script.proto
 * Coordinates for geocoding.
 *
 * SOURCE Coordinates @ squareup/address/service.proto at 25:1
 */
export const Coordinates = $root.lookupType('squareup.address.service.Coordinates');
fixType(Coordinates, {
  latitude: {
    required: true
  },
  longitude: {
    required: true
  }
});
Builder.createAndAttachToType(Coordinates);
/**
 * Measure of geocoding accuracy.  Higher ids are presumed more accurate.
 *
 * SOURCE GeocodeAccuracy @ squareup/address/service.proto at 29:3
 */
Coordinates.GeocodeAccuracy = $root.lookupEnum('squareup.address.service.Coordinates.GeocodeAccuracy').values;
/**
 * SOURCE PiiStatusScope @ squareup/address/service.proto at 88:1
 */
export const PiiStatusScope = $root.lookupType('squareup.address.service.PiiStatusScope');
fixType(PiiStatusScope);
Builder.createAndAttachToType(PiiStatusScope);
/**
 * SOURCE PiiStatus @ squareup/address/service.proto at 89:3
 */
PiiStatusScope.PiiStatus = $root.lookupEnum('squareup.address.service.PiiStatusScope.PiiStatus').values;
/**
 * SOURCE ResidentialScope @ squareup/address/service.proto at 103:1
 */
export const ResidentialScope = $root.lookupType('squareup.address.service.ResidentialScope');
fixType(ResidentialScope);
Builder.createAndAttachToType(ResidentialScope);
/**
 * SOURCE Residential @ squareup/address/service.proto at 104:3
 */
ResidentialScope.Residential = $root.lookupEnum('squareup.address.service.ResidentialScope.Residential').values;
/**
 * SOURCE AddressTypeScope @ squareup/address/service.proto at 115:1
 */
export const AddressTypeScope = $root.lookupType('squareup.address.service.AddressTypeScope');
fixType(AddressTypeScope);
Builder.createAndAttachToType(AddressTypeScope);
/**
 * SOURCE AddressType @ squareup/address/service.proto at 116:3
 */
AddressTypeScope.AddressType = $root.lookupEnum('squareup.address.service.AddressTypeScope.AddressType').values;
/**
 * SOURCE Address @ squareup/address/service.proto at 139:1
 */
export const Address = $root.lookupType('squareup.address.service.Address');
fixType(Address);
Builder.createAndAttachToType(Address);
/**
 * SOURCE Verification @ squareup/address/service.proto at 189:1
 */
export const Verification = $root.lookupType('squareup.address.service.Verification');
fixType(Verification);
Builder.createAndAttachToType(Verification);
/**
 * SOURCE VerificationStatus @ squareup/address/service.proto at 200:3
 */
Verification.VerificationStatus = $root.lookupEnum('squareup.address.service.Verification.VerificationStatus').values;
/**
 * SOURCE VerificationLevel @ squareup/address/service.proto at 222:3
 */
Verification.VerificationLevel = $root.lookupEnum('squareup.address.service.Verification.VerificationLevel').values;
/**
 * ===== END DEPRECATED DEFINITIONS
 * nested enum just to avoid shared global scope of enum constants
 *
 * SOURCE RequirementsScope @ squareup/address/service.proto at 257:1
 */
export const RequirementsScope = $root.lookupType('squareup.address.service.RequirementsScope');
fixType(RequirementsScope);
Builder.createAndAttachToType(RequirementsScope);
/**
 * Requirements on an address in order for it to be accepted in the Address service.
 *
 * SOURCE Requirements @ squareup/address/service.proto at 261:3
 */
RequirementsScope.Requirements = $root.lookupEnum('squareup.address.service.RequirementsScope.Requirements').values;
/**
 * nested enum just to avoid shared global scope of enum constants
 *
 * SOURCE ServicesScope @ squareup/address/service.proto at 282:1
 */
export const ServicesScope = $root.lookupType('squareup.address.service.ServicesScope');
fixType(ServicesScope);
Builder.createAndAttachToType(ServicesScope);
/**
 * A service to perform on a newly supplied address.
 *
 * SOURCE Services @ squareup/address/service.proto at 286:3
 */
ServicesScope.Services = $root.lookupEnum('squareup.address.service.ServicesScope.Services').values;
/**
 * nested enum just to avoid shared global scope of enum constants
 *
 * SOURCE FlagsScope @ squareup/address/service.proto at 296:1
 */
export const FlagsScope = $root.lookupType('squareup.address.service.FlagsScope');
fixType(FlagsScope);
Builder.createAndAttachToType(FlagsScope);
/**
 * SOURCE Flags @ squareup/address/service.proto at 297:3
 */
FlagsScope.Flags = $root.lookupEnum('squareup.address.service.FlagsScope.Flags').values;
/**
 * [Internal] Holds request context details of the RPC that triggered an address vendor request.
 *
 * SOURCE RequestContext @ squareup/address/service.proto at 320:1
 */
export const RequestContext = $root.lookupType('squareup.address.service.RequestContext');
fixType(RequestContext);
Builder.createAndAttachToType(RequestContext);
/**
 * [Internal] The message that gets stored in JobQueue for performing async services on an address.
 *
 * SOURCE AsyncJob @ squareup/address/service.proto at 334:1
 */
export const AsyncJob = $root.lookupType('squareup.address.service.AsyncJob');
fixType(AsyncJob);
Builder.createAndAttachToType(AsyncJob);
/**
 * SOURCE StoreRequest @ squareup/address/service.proto at 348:1
 */
export const StoreRequest = $root.lookupType('squareup.address.service.StoreRequest');
fixType(StoreRequest);
Builder.createAndAttachToType(StoreRequest);
/**
 * SOURCE Constants @ squareup/address/service.proto at 349:3
 */
StoreRequest.Constants = $root.lookupEnum('squareup.address.service.StoreRequest.Constants').values;
/**
 * SOURCE AddressResult @ squareup/address/service.proto at 381:1
 */
export const AddressResult = $root.lookupType('squareup.address.service.AddressResult');
fixType(AddressResult);
Builder.createAndAttachToType(AddressResult);
/**
 * SOURCE Status @ squareup/address/service.proto at 382:3
 */
AddressResult.Status = $root.lookupEnum('squareup.address.service.AddressResult.Status').values;
/**
 * Read-only lookup of one or more address tokens.
 *
 * SOURCE RetrieveRequest @ squareup/address/service.proto at 440:1
 */
export const RetrieveRequest = $root.lookupType('squareup.address.service.RetrieveRequest');
fixType(RetrieveRequest);
Builder.createAndAttachToType(RetrieveRequest);
/**
 * SOURCE RetrieveResponse @ squareup/address/service.proto at 445:1
 */
export const RetrieveResponse = $root.lookupType('squareup.address.service.RetrieveResponse');
fixType(RetrieveResponse);
Builder.createAndAttachToType(RetrieveResponse);
/**
 * Lookup of an address token, ensuring that requested services/flags are provided.  This may
 * modify the address record and may invoke external services, so should be used carefully.  Note
 * that it is possible for the address token to change when requesting address standardization if
 * the previously stored address was not standardized, so you should check the returned token to see
 * if you need to update the token for the address.
 *
 * SOURCE RetrieveWithUpgradeRequest @ squareup/address/service.proto at 465:1
 */
export const RetrieveWithUpgradeRequest = $root.lookupType('squareup.address.service.RetrieveWithUpgradeRequest');
fixType(RetrieveWithUpgradeRequest);
Builder.createAndAttachToType(RetrieveWithUpgradeRequest);
/**
 * SOURCE LookupPostalCodeRequest @ squareup/address/service.proto at 481:1
 */
export const LookupPostalCodeRequest = $root.lookupType('squareup.address.service.LookupPostalCodeRequest');
fixType(LookupPostalCodeRequest);
Builder.createAndAttachToType(LookupPostalCodeRequest);
/**
 * SOURCE LookupPostalCodeResponse @ squareup/address/service.proto at 492:1
 */
export const LookupPostalCodeResponse = $root.lookupType('squareup.address.service.LookupPostalCodeResponse');
fixType(LookupPostalCodeResponse);
Builder.createAndAttachToType(LookupPostalCodeResponse);
/**
 * SOURCE Match @ squareup/address/service.proto at 511:3
 */
LookupPostalCodeResponse.Match = $root.lookupType('squareup.address.service.LookupPostalCodeResponse.Match');
fixType(LookupPostalCodeResponse.Match);
Builder.createAndAttachToType(LookupPostalCodeResponse.Match);
/**
 * SOURCE ReverseGeocodeRequest @ squareup/address/service.proto at 530:1
 */
export const ReverseGeocodeRequest = $root.lookupType('squareup.address.service.ReverseGeocodeRequest');
fixType(ReverseGeocodeRequest);
Builder.createAndAttachToType(ReverseGeocodeRequest);
/**
 * SOURCE ReverseGeocodeResponse @ squareup/address/service.proto at 535:1
 */
export const ReverseGeocodeResponse = $root.lookupType('squareup.address.service.ReverseGeocodeResponse');
fixType(ReverseGeocodeResponse);
Builder.createAndAttachToType(ReverseGeocodeResponse);
/**
 * SOURCE Entry @ squareup/address/service.proto at 536:3
 */
ReverseGeocodeResponse.Entry = $root.lookupType('squareup.address.service.ReverseGeocodeResponse.Entry');
fixType(ReverseGeocodeResponse.Entry);
Builder.createAndAttachToType(ReverseGeocodeResponse.Entry);
/**
 * SOURCE LookupCountryAddressDataRequest @ squareup/address/service.proto at 548:1
 */
export const LookupCountryAddressDataRequest = $root.lookupType('squareup.address.service.LookupCountryAddressDataRequest');
fixType(LookupCountryAddressDataRequest);
Builder.createAndAttachToType(LookupCountryAddressDataRequest);
/**
 * the following request and response protos are designed for querying the Google Place
 * Autocomplete API. The client sends the request with partial address input, the
 * country code, and the session token. The server queries the Google Place Autocomplete
 * API to get a list of full addresses that match the partial input and sends it back
 * to the client
 *
 * Please refer to: https://developers.google.com/places/web-service/autocomplete
 *
 * SOURCE GetAutocompleteCandidatesRequest @ squareup/address/service.proto at 565:1
 */
export const GetAutocompleteCandidatesRequest = $root.lookupType('squareup.address.service.GetAutocompleteCandidatesRequest');
fixType(GetAutocompleteCandidatesRequest);
Builder.createAndAttachToType(GetAutocompleteCandidatesRequest);
/**
 * Type collections supported in Place Autocomplete requests
 * https://developers.google.com/maps/documentation/places/web-service/supported_types#table3
 *
 * SOURCE PlaceAutocompleteTypesScope @ squareup/address/service.proto at 583:1
 */
export const PlaceAutocompleteTypesScope = $root.lookupType('squareup.address.service.PlaceAutocompleteTypesScope');
fixType(PlaceAutocompleteTypesScope);
Builder.createAndAttachToType(PlaceAutocompleteTypesScope);
/**
 * SOURCE PlaceAutocompleteType @ squareup/address/service.proto at 584:3
 */
PlaceAutocompleteTypesScope.PlaceAutocompleteType = $root.lookupEnum('squareup.address.service.PlaceAutocompleteTypesScope.PlaceAutocompleteType').values;
/**
 * SOURCE GetAutocompleteCandidatesResponse @ squareup/address/service.proto at 594:1
 */
export const GetAutocompleteCandidatesResponse = $root.lookupType('squareup.address.service.GetAutocompleteCandidatesResponse');
fixType(GetAutocompleteCandidatesResponse);
Builder.createAndAttachToType(GetAutocompleteCandidatesResponse);
/**
 * SOURCE AddressCandidate @ squareup/address/service.proto at 595:3
 */
GetAutocompleteCandidatesResponse.AddressCandidate = $root.lookupType('squareup.address.service.GetAutocompleteCandidatesResponse.AddressCandidate');
fixType(GetAutocompleteCandidatesResponse.AddressCandidate);
Builder.createAndAttachToType(GetAutocompleteCandidatesResponse.AddressCandidate);
/**
 * SOURCE PlaceAutocompleteStructuredFormat @ squareup/address/service.proto at 607:3
 */
GetAutocompleteCandidatesResponse.PlaceAutocompleteStructuredFormat = $root.lookupType('squareup.address.service.GetAutocompleteCandidatesResponse.PlaceAutocompleteStructuredFormat');
fixType(GetAutocompleteCandidatesResponse.PlaceAutocompleteStructuredFormat);
Builder.createAndAttachToType(GetAutocompleteCandidatesResponse.PlaceAutocompleteStructuredFormat);
/**
 * the following request and response protos are designed for querying the Google Place
 * Details API. The client sends the request with place id and session token to the server,
 * and the server queries Google Place Details API to obtain the details about the place,
 * e.g., the structured global address and the coordinates of the place. One scenario of
 * using this API is for the client to call the autocomplete API first to get a list of
 * candidate addresses that match the client's input, each comes with a place id, once the
 * client finalizes on the address by choosing one of the candidate, they can then use the
 * place id of the chosen address to query for the place details using the API below
 *
 * Please refer to: https://developers.google.com/places/web-service/details
 *
 * SOURCE GetPlaceDetailsRequest @ squareup/address/service.proto at 628:1
 */
export const GetPlaceDetailsRequest = $root.lookupType('squareup.address.service.GetPlaceDetailsRequest');
fixType(GetPlaceDetailsRequest);
Builder.createAndAttachToType(GetPlaceDetailsRequest);
/**
 * SOURCE GetPlaceDetailsResponse @ squareup/address/service.proto at 638:1
 */
export const GetPlaceDetailsResponse = $root.lookupType('squareup.address.service.GetPlaceDetailsResponse');
fixType(GetPlaceDetailsResponse);
Builder.createAndAttachToType(GetPlaceDetailsResponse);
/**
 * the following request and response protos are designed for autocompleting a partial address
 * input string from callers. The client sends the request with partial address input, the
 * country code, and the session token. The server responds back with a list of full addresses
 * that match the partial input
 *
 * SOURCE FeGetAutocompleteCandidatesRequest @ squareup/address/service.proto at 751:1
 */
export const FeGetAutocompleteCandidatesRequest = $root.lookupType('squareup.address.service.FeGetAutocompleteCandidatesRequest');
fixType(FeGetAutocompleteCandidatesRequest);
Builder.createAndAttachToType(FeGetAutocompleteCandidatesRequest);
/**
 * SOURCE FeGetAutocompleteCandidatesResponse @ squareup/address/service.proto at 767:1
 */
export const FeGetAutocompleteCandidatesResponse = $root.lookupType('squareup.address.service.FeGetAutocompleteCandidatesResponse');
fixType(FeGetAutocompleteCandidatesResponse);
Builder.createAndAttachToType(FeGetAutocompleteCandidatesResponse);
/**
 * SOURCE AddressCandidate @ squareup/address/service.proto at 768:3
 */
FeGetAutocompleteCandidatesResponse.AddressCandidate = $root.lookupType('squareup.address.service.FeGetAutocompleteCandidatesResponse.AddressCandidate');
fixType(FeGetAutocompleteCandidatesResponse.AddressCandidate);
Builder.createAndAttachToType(FeGetAutocompleteCandidatesResponse.AddressCandidate);
/**
 * SOURCE PlaceAutocompleteStructuredFormat @ squareup/address/service.proto at 780:3
 */
FeGetAutocompleteCandidatesResponse.PlaceAutocompleteStructuredFormat = $root.lookupType('squareup.address.service.FeGetAutocompleteCandidatesResponse.PlaceAutocompleteStructuredFormat');
fixType(FeGetAutocompleteCandidatesResponse.PlaceAutocompleteStructuredFormat);
Builder.createAndAttachToType(FeGetAutocompleteCandidatesResponse.PlaceAutocompleteStructuredFormat);
/**
 * the following request and response protos are designed for getting place details given
 * the place id. The client sends the request with place id and session token to the server,
 * and the server obtains the details about the place, e.g., the structured global address
 * and the coordinates of the place, and sends the response back to the client. One scenario
 * of using this API is for the client to call the autocomplete API first to get a list of
 * candidate addresses that match the client's input, each comes with a place id, once the
 * client finalizes on the address by choosing one of the candidate, they can then use the
 * place id of the chosen address to query for the place details using the API below
 *
 * SOURCE FeGetPlaceDetailsRequest @ squareup/address/service.proto at 799:1
 */
export const FeGetPlaceDetailsRequest = $root.lookupType('squareup.address.service.FeGetPlaceDetailsRequest');
fixType(FeGetPlaceDetailsRequest);
Builder.createAndAttachToType(FeGetPlaceDetailsRequest);
/**
 * SOURCE FeGetPlaceDetailsResponse @ squareup/address/service.proto at 809:1
 */
export const FeGetPlaceDetailsResponse = $root.lookupType('squareup.address.service.FeGetPlaceDetailsResponse');
fixType(FeGetPlaceDetailsResponse);
Builder.createAndAttachToType(FeGetPlaceDetailsResponse);
/**
 * ===============================================================
 * GET /country_address_data?country=$COUNTRY&locale=$LOCALE
 * ==============================================================
 * Lookup address data for a given country
 *
 * SOURCE FeCountryAddressDataRequest @ squareup/address/service.proto at 836:1
 */
export const FeCountryAddressDataRequest = $root.lookupType('squareup.address.service.FeCountryAddressDataRequest');
fixType(FeCountryAddressDataRequest);
Builder.createAndAttachToType(FeCountryAddressDataRequest);
/**
 * response is CountryAddressData
 * Format an address, such as for a mailing label.
 *
 * SOURCE FeFormatRequest @ squareup/address/service.proto at 850:1
 */
export const FeFormatRequest = $root.lookupType('squareup.address.service.FeFormatRequest');
fixType(FeFormatRequest);
Builder.createAndAttachToType(FeFormatRequest);
/**
 * SOURCE FeFormatResponse @ squareup/address/service.proto at 865:1
 */
export const FeFormatResponse = $root.lookupType('squareup.address.service.FeFormatResponse');
fixType(FeFormatResponse);
Builder.createAndAttachToType(FeFormatResponse);
/**
 * ===============================================================
 * GET /retrieve?token=$TOKEN
 * ==============================================================
 * Read-only lookup of one or more address tokens.
 *
 * SOURCE FeRetrieveRequest @ squareup/address/service.proto at 885:1
 */
export const FeRetrieveRequest = $root.lookupType('squareup.address.service.FeRetrieveRequest');
fixType(FeRetrieveRequest);
Builder.createAndAttachToType(FeRetrieveRequest);
/**
 * SOURCE FeRetrieveResponse @ squareup/address/service.proto at 891:1
 */
export const FeRetrieveResponse = $root.lookupType('squareup.address.service.FeRetrieveResponse');
fixType(FeRetrieveResponse);
Builder.createAndAttachToType(FeRetrieveResponse);
/**
 * SOURCE FeValidateAddressRequest @ squareup/address/service.proto at 899:1
 */
export const FeValidateAddressRequest = $root.lookupType('squareup.address.service.FeValidateAddressRequest');
fixType(FeValidateAddressRequest);
Builder.createAndAttachToType(FeValidateAddressRequest);
/**
 * SOURCE Constants @ squareup/address/service.proto at 900:3
 */
FeValidateAddressRequest.Constants = $root.lookupEnum('squareup.address.service.FeValidateAddressRequest.Constants').values;
/**
 * SOURCE FeValidateAddressResponse @ squareup/address/service.proto at 909:1
 */
export const FeValidateAddressResponse = $root.lookupType('squareup.address.service.FeValidateAddressResponse');
fixType(FeValidateAddressResponse);
Builder.createAndAttachToType(FeValidateAddressResponse);
/**
 * SOURCE Status @ squareup/address/service.proto at 910:3
 */
FeValidateAddressResponse.Status = $root.lookupEnum('squareup.address.service.FeValidateAddressResponse.Status').values;
/**
 * SOURCE AddressService @ squareup/address/service.proto at 658:1
 */
export const AddressService = $root.lookupService('squareup.address.service.AddressService');
/**
 * This service is not actually exposed, but some clients needs this to talk to AddressFE.
 * The options match AddressService and are for documentation purposes only.
 *
 * SOURCE AddressFrontendService @ squareup/address/service.proto at 710:1
 */
export const AddressFrontendService = $root.lookupService('squareup.address.service.AddressFrontendService');